module.exports = __webpack_public_path__ + "static/tech-5692bdb1e9525fdf6bcccd3faf4ceae4.svg";